"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = default_1;
const moment_1 = __importDefault(require("moment"));
const i18n_config_1 = __importDefault(require("evolution-frontend/lib/config/i18n.config"));
const LodashExtensions_1 = require("chaire-lib-common/lib/utils/LodashExtensions");
const surveyHelperNew = __importStar(require("evolution-common/lib/utils/helpers"));
const odSurveyHelper = __importStar(require("evolution-common/lib/services/odSurvey/helpers"));
// TODO: This custom file should be generated by the Evolution Generator (or eliminated complety).
// TODO: We need this file to setup the interview (language, section start time, actions, household persons count (?)).
// TODO: We also need this file to reject some interviews that are not valid (home not in territory, no adults in household).
// TODO: In other words, if we can improve the Group and Section navigation in Evolution, we can eliminate this file completely.
function default_1(interview, sectionShortname) {
    moment_1.default.locale(i18n_config_1.default.language); // seems we need this because it is not set correctly globally
    // If home is not in the territory, make sure to redirect to completed section
    if (sectionShortname !== 'home' && sectionShortname !== 'completed') {
        const homeInTerritory = surveyHelperNew.getResponse(interview, 'home._homeIsInTerritory', undefined);
        if (homeInTerritory === false) {
            return {
                'response._activeSection': 'completed'
            };
        }
    }
    // If household don't have any adults, make sure to redirect to completed section
    if (sectionShortname !== 'home' && sectionShortname !== 'household' && sectionShortname !== 'completed') {
        const countAdults = odSurveyHelper.countAdults({ interview });
        if (countAdults === 0) {
            return {
                'response._activeSection': 'completed'
            };
        }
    }
    // Prepare the responses object with the household persons count
    const responses = {
        ['response.household._personsCount']: odSurveyHelper.countPersons({ interview })
    };
    // Check if household size and persons are in sync
    if (sectionShortname !== 'home' && sectionShortname !== 'household') {
        const householdSize = surveyHelperNew.getResponse(interview, 'household.size', undefined);
        const householdPersons = surveyHelperNew.getResponse(interview, 'household.persons', undefined);
        if (!(0, LodashExtensions_1._isBlank)(householdSize) && !(0, LodashExtensions_1._isBlank)(householdPersons)) {
            const personsCount = odSurveyHelper.countPersons({ interview });
            if (personsCount !== householdSize) {
                responses['response.household.size'] = personsCount;
            }
        }
    }
    return responses;
}
